<template>
  <div class="form-checkbox-inputs">
    <BFormGroup :label="label">
      <BFormCheckboxGroup
        :checked="value"
        :options="options"
        :name="name"
        v-bind="$attrs"
        v-on="$listeners"
      />
    </BFormGroup>
  </div>
</template>

<script>
import {BFormGroup} from 'bootstrap-vue/src/components/form-group/form-group'
import {BFormCheckboxGroup} from 'bootstrap-vue/src/components/form-checkbox/form-checkbox-group'

export default {

  components: {
    BFormCheckboxGroup,
    BFormGroup,
  },
  inheritAttrs: false,

  props: {
    /**
     * The current value of the checked radio in the group
     */
    value: {
      type: [String, Object, Boolean, Array],
      required: true,
    },

    label: {
      type: String,
      default: undefined,
    },

    /**
     * Sets the value of the 'name' attribute on the form control
     */
    name: {
      type: String,
      default: undefined,
    },

    /**
     * Array of items to render in the component
     */
    options: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">

@import "./index";

.form-checkbox-inputs {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;

  .col-form-label {
    font-size: $font-size-sm;
    color: $gray-800;
    padding-top: 0 !important;
    padding-bottom: 0.75rem;
    margin-bottom: 0;
  }
}
</style>
